import { CampaignSettingModal } from "./CampaignSettingModal";

export default CampaignSettingModal;

export { CampaignSettingModal };
